import { useState, useEffect, useCallback } from 'react';

const VERSION_CHECK_INTERVAL = 60000; // 1 dakikada bir kontrol et (ms)
const VERSION_URL = '/version.json';

export function useVersionCheck() {
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const [currentBuildTime, setCurrentBuildTime] = useState(null);

  const checkVersion = useCallback(async () => {
    try {
      // Cache'i bypass etmek için timestamp ekle
      const response = await fetch(`${VERSION_URL}?t=${Date.now()}`);
      if (!response.ok) return;

      const data = await response.json();
      const serverBuildTime = data.buildTime;

      if (currentBuildTime === null) {
        // İlk yükleme - mevcut build zamanını kaydet
        setCurrentBuildTime(serverBuildTime);
      } else if (serverBuildTime > currentBuildTime) {
        // Sunucuda daha yeni bir versiyon var
        setHasNewVersion(true);
      }
    } catch (error) {
      // Version kontrolü başarısız olursa sessizce devam et
      console.warn('Version check failed:', error);
    }
  }, [currentBuildTime]);

  useEffect(() => {
    // İlk kontrol
    checkVersion();

    // Periyodik kontrol
    const intervalId = setInterval(checkVersion, VERSION_CHECK_INTERVAL);

    return () => clearInterval(intervalId);
  }, [checkVersion]);

  const dismissUpdate = useCallback(() => {
    setHasNewVersion(false);
  }, []);

  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  return {
    hasNewVersion,
    dismissUpdate,
    refreshPage
  };
}
